export default __webpack_public_path__ + "static/media/info-icon.db662602.png";